import React from "react";
import InterviewHeader from "./InterviewHeader";

interface SetupPageLayoutProps {
  children: React.ReactNode;
  progressTracker?: React.ReactNode;
}

const SetupPageLayout: React.FC<SetupPageLayoutProps> = ({
  children,
  progressTracker,
}) => {
  return (
    <div className="flex flex-col items-center h-screen max-h-screen w-full bg-background-grey overflow-y-auto minimal-scrollbar pb-6 xl:pb-0">
      <InterviewHeader />
      <div className="flex flex-col w-[70%] mx-auto pt-[24px] mt-[76px]">
        {progressTracker && <div className="w-full mb-[32px]">{progressTracker}</div>}
        {children}
      </div>
    </div>
  );
};

export default SetupPageLayout;
